const translations = {};

translations["MSG_APP_ERROR_PASSWORD_CONFIRM_NOT_VALID"] = "パスワードが一致していません。";
translations["MSG_APP_ERROR_PASSWORD_TOO_SHORT"] = "6文字以上のパスワードを入力してください。";
translations["MSG_APP_VERSION_UPDATE_WARNING_MESSAGE"] =
  "最新版のアプリがあります。\n最新の機能を利用する為にアップデートが必要です。\nアップデートはすぐに完了します。";
translations["MSG_APP_VERSION_UPDATE_WARNING_TITLE"] = "アプリを最新版にアップデートします。";
translations["MSG_ASSISTANT_PLACEHOLDER"] = "メッセージを入れてね...";
translations["MSG_ASSISTANT_SEND"] = "送る";
translations["MSG_BACK_BTN"] = "戻る";
translations["MSG_BACK_BTN_BY_PARENT"] = "戻る";
translations["MSG_BIRTHDAY_DAY_SUFFIX_BY_PARENT"] = "日";
translations["MSG_BIRTHDAY_MONTH_SUFFIX_BY_PARENT"] = "月";
translations["MSG_BIRTHDAY_YEAR_SUFFIX_BY_PARENT"] = "年";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT"] = "%{limit}文字以内で入力してください。";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT_BY_PARENT"] = "%{limit}文字以内";
translations["MSG_BODY_TYPE_CHUBBY_BY_PARENT"] = "太め";
translations["MSG_BODY_TYPE_MEDIUM_BY_PARENT"] = "普通";
translations["MSG_BODY_TYPE_SLIGHTLY_CHUBBY_BY_PARENT"] = "やや太め";
translations["MSG_BODY_TYPE_SLIGHTLY_THIN_BY_PARENT"] = "やや細め";
translations["MSG_BODY_TYPE_THIN_BY_PARENT"] = "細め";
translations["MSG_BODY_TYPE_TITLE_BY_PARENT"] = "体型";
translations["MSG_BOYS_COUNT"] = "男の子";
translations["MSG_BTN_CLOSE"] = "閉じる";
translations["MSG_BTN_LATER"] = "あとで";
translations["MSG_CANCEL_BTN"] = "キャンセル";
translations["MSG_CANCEL_BTN_BY_PARENT"] = "キャンセル";
translations["MSG_CITY_TITLE"] = "地域";
translations["MSG_COLOR_BLUE_BY_PARENT"] = "青";
translations["MSG_COLOR_GREEN_BY_PARENT"] = "緑";
translations["MSG_COLOR_OTHER_PLACEHOLDER_BY_PARENT"] = "自己紹介の色を入力";
translations["MSG_COLOR_RED_BY_PARENT"] = "赤";
translations["MSG_COLOR_SELECT_SHADE"] = "好きな色味を選んでね";
translations["MSG_COLOR_WHITE_BY_PARENT"] = "白";
translations["MSG_COLOR_YELLOW_BY_PARENT"] = "黄色";
translations["MSG_COMPANY_SIZE_ENTERPRISE"] = "1001人以上";
translations["MSG_COMPANY_SIZE_LARGE"] = "301-1000人";
translations["MSG_COMPANY_SIZE_MEDIUM"] = "51-300人";
translations["MSG_COMPANY_SIZE_MICRO"] = "1-10人";
translations["MSG_COMPANY_SIZE_SMALL"] = "11-50人";
translations["MSG_COMPANY_SIZE_SOLO"] = "個人事業主";
translations["MSG_COMPANY_SIZE_TITLE"] = "会社規模";
translations["MSG_CONFIRM_BTN_BY_PARENT"] = "決定";
translations["MSG_COURSE_ALGORITHM"] = "アルゴリズムをまなぼう！";
translations["MSG_COURSE_ALGORITHM_ADVANCED"] = "アルゴリズム上級";
translations["MSG_COURSE_GROUP_WORK"] = "グループワーク";
translations["MSG_COURSE_PROGRAM"] = "はじめてのプログラミング";
translations["MSG_SETTING_COURSE_ANSWER_COURSE_TITLE"] = "コースを選ぶ";
translations["MSG_SETTING_COURSE_ANSWER_STAGE_TITLE"] = "ステージを選ぶ";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL_TITLE"] = "レベルを選ぶ";
translations["MSG_SETTING_COURSE_ANSWER_STAGE"] = "ステージ";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL"] = "レベル";
translations["MSG_ERROR_NETWORK"] = "ネットワークエラー";
translations["MSG_FACE_SHAPE_OBLONG_BY_PARENT"] = "面長";
translations["MSG_FACE_SHAPE_OVAL_BY_PARENT"] = "卵型";
translations["MSG_FACE_SHAPE_ROUND_BY_PARENT"] = "丸型";
translations["MSG_FACE_SHAPE_SQUARE_BY_PARENT"] = "四角型";
translations["MSG_FACE_SHAPE_TITLE_BY_PARENT"] = "顔の形";
translations["MSG_FACE_SHAPE_TRIANGLE_BY_PARENT"] = "三角型";
translations["MSG_GENDER_FEMALE_BY_PARENT"] = "女の子";
translations["MSG_GENDER_MALE_BY_PARENT"] = "男の子";
translations["MSG_GENDER_NONE"] = "なし";
translations["MSG_GENERATE_BTN_BY_PARENT"] = "生成";
translations["MSG_GIRLS_COUNT"] = "女の子";
translations["MSG_GLASSES_NONE_BY_PARENT"] = "なし";
translations["MSG_GLASSES_TITLE_BY_PARENT"] = "眼鏡";
translations["MSG_GLASSES_YES_BY_PARENT"] = "あり";
translations["MSG_HAIRSTYLE_LONG_BY_PARENT"] = "長め";
translations["MSG_HAIRSTYLE_MEDIUM_BY_PARENT"] = "普通";
translations["MSG_HAIRSTYLE_SHORT_BY_PARENT"] = "短め";
translations["MSG_HAIRSTYLE_SLIGHTLY_LONG_BY_PARENT"] = "やや長め";
translations["MSG_HAIRSTYLE_TITLE_BY_PARENT"] = "髪型";
translations["MSG_HAIRSTYLE_VERY_SHORT_BY_PARENT"] = "かなり短め";
translations["MSG_HOUSEHOLD_MEMBERS_TITLE"] = "同居人";
translations["MSG_HOUSEHOLD_MEMBER_FATHER"] = "父親";
translations["MSG_HOUSEHOLD_MEMBER_GRANDFATHER"] = "祖父";
translations["MSG_HOUSEHOLD_MEMBER_GRANDMOTHER"] = "祖母";
translations["MSG_HOUSEHOLD_MEMBER_MOTHER"] = "母親";
translations["MSG_ICON_CATEGORY_ALL"] = "すべて";
translations["MSG_ICON_CATEGORY_BOY_BY_PARENT"] = "男の子";
translations["MSG_ICON_CATEGORY_GIRL_BY_PARENT"] = "女の子";
translations["MSG_ICON_CHANGE_PREVIEW_CURRENT_PARENT"] = "現在";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED_PARENT"] = "選択中";
translations["MSG_ICON_CONFIRM_BTN_BY_PARENT"] = "これでいい";
translations["MSG_ICON_CONFIRM_PROMPT_BY_PARENT"] = "このアイコンでよろしいですか？";
translations["MSG_ICON_GENERATING_BY_PARENT"] = "アイコンを作成しています...";
translations["MSG_ICON_REGENERATE_BTN_BY_PARENT"] = "もう一度作る";
translations["MSG_ICON_CREATE_BTN"] = "作る";
translations["MSG_ICON_ADDITIONAL_PROMPT_PLACEHOLDER"] = "追加したいことがあれば";
translations["MSG_ICON_SELECT_PROFILE_AI_BY_PARENT"] = "プロフィールで\nAIで自動で\n作る";
translations["MSG_ICON_SELECT_SYSTEM_BY_PARENT"] = "用意された\nアイコン";
translations["MSG_ICON_SELECT_TITLE_BY_PARENT"] = "お子さまのアイコンを選んでください";
translations["MSG_ICON_SELECT_UPLOAD_BY_PARENT"] = "画像を\nアップロード";
translations["MSG_INDUSTRY_TITLE"] = "業種";
translations["MSG_INDUSTRY_IT"] = "IT・通信";
translations["MSG_INDUSTRY_MANUFACTURING"] = "製造業";
translations["MSG_INDUSTRY_FINANCE"] = "金融・保険";
translations["MSG_INDUSTRY_RETAIL"] = "小売・卸売";
translations["MSG_INDUSTRY_HEALTHCARE"] = "医療・福祉";
translations["MSG_INDUSTRY_EDUCATION"] = "教育";
translations["MSG_INDUSTRY_GOVERNMENT"] = "官公庁・公務員";
translations["MSG_INDUSTRY_REAL_ESTATE"] = "不動産";
translations["MSG_INDUSTRY_CONSTRUCTION"] = "建設";
translations["MSG_INDUSTRY_TRANSPORTATION"] = "運輸・物流";
translations["MSG_INDUSTRY_MEDIA"] = "メディア・広告";
translations["MSG_INDUSTRY_SERVICE"] = "サービス業";
translations["MSG_INDUSTRY_OTHER"] = "その他";
translations["MSG_JOB_TITLE_LABEL"] = "役職・立場";
translations["MSG_JOB_TITLE_EXECUTIVE"] = "経営者・役員";
translations["MSG_JOB_TITLE_MANAGER"] = "管理職";
translations["MSG_JOB_TITLE_GENERAL"] = "一般職";
translations["MSG_JOB_TITLE_PROFESSIONAL"] = "専門職";
translations["MSG_JOB_TITLE_HOMEMAKER"] = "役職なし（専業主婦／主夫）";
translations["MSG_JOB_TITLE_STUDENT"] = "役職なし（学生）";
translations["MSG_JOB_TITLE_UNEMPLOYED"] = "役職なし（無職）";
translations["MSG_LOADING"] = "読み込み中...";
translations["MSG_NEXT_BTN_BY_PARENT"] = "次へ";
translations["MSG_NOTIFICATION_DEFAULT_TITLE"] = "お知らせ";
translations["MSG_OCCUPATION_TITLE"] = "職種";
translations["MSG_OCCUPATION_EXECUTIVE"] = "経営・役員";
translations["MSG_OCCUPATION_MANAGER"] = "管理職";
translations["MSG_OCCUPATION_ENGINEER"] = "エンジニア・技術職";
translations["MSG_OCCUPATION_SALES"] = "営業";
translations["MSG_OCCUPATION_MARKETING"] = "マーケティング";
translations["MSG_OCCUPATION_HR"] = "人事・総務";
translations["MSG_OCCUPATION_ACCOUNTING"] = "経理・財務";
translations["MSG_OCCUPATION_RESEARCHER"] = "研究・開発";
translations["MSG_OCCUPATION_TEACHER"] = "教員・講師";
translations["MSG_OCCUPATION_DOCTOR"] = "医師";
translations["MSG_OCCUPATION_NURSE"] = "看護師";
translations["MSG_OCCUPATION_LAWYER"] = "弁護士・法務";
translations["MSG_OCCUPATION_DESIGNER"] = "デザイナー";
translations["MSG_OCCUPATION_FREELANCE"] = "フリーランス";
translations["MSG_OCCUPATION_HOMEMAKER"] = "専業主婦・主夫";
translations["MSG_OCCUPATION_STUDENT"] = "学生";
translations["MSG_OCCUPATION_OTHER"] = "その他";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_BTN"] = "プランを見る";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_MESSAGE"] =
  "画像の送信は「特別プラン」で使えます\n特別プランにアップグレードすると、画像を送ることができます";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_TITLE"] = "画像機能について";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_SELECT"] = "選択";
translations["MSG_PARENT_ONBOARDING_BTN_BACK"] = "戻る";
translations["MSG_PARENT_ONBOARDING_BTN_CONFIRM"] = "確定";
translations["MSG_PARENT_ONBOARDING_BTN_GENERATE"] = "作成";
translations["MSG_PARENT_ONBOARDING_BTN_NEXT"] = "次へ";
translations["MSG_PARENT_ONBOARDING_BTN_REGENERATE"] = "再生成";
translations["MSG_PARENT_ONBOARDING_GENDER_FEMALE"] = "女性";
translations["MSG_PARENT_ONBOARDING_GENDER_MALE"] = "男性";
translations["MSG_PARENT_ONBOARDING_ICON_METHOD_TITLE"] = "アイコンを選択してください";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET"] = "用意された\nアイコン";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET_TITLE"] = "アイコンを選択してください";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_CONFIRM"] = "確認";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_GENERATING"] = "生成中...";
translations["MSG_PARENT_ONBOARDING_ICON_PROFILE_AI"] = "プロフィールで\nAIで自動で\n作る";
translations["MSG_PARENT_ONBOARDING_ICON_UPLOAD"] = "画像を\nアップロード";
translations["MSG_PARENT_ONBOARDING_INCOME_5M_10M"] = "500〜1000万円";
translations["MSG_PARENT_ONBOARDING_INCOME_OVER_10M"] = "1000万円以上";
translations["MSG_PARENT_ONBOARDING_INCOME_PREFER_NOT_TO_SAY"] = "回答しない";
translations["MSG_PARENT_ONBOARDING_INCOME_TITLE"] = "世帯収入";
translations["MSG_PARENT_ONBOARDING_INCOME_UNDER_5M"] = "500万円未満";
translations["MSG_PARENT_ONBOARDING_UPLOAD_HINT"] = "JPG、PNG（5MB以下）";
translations["MSG_PARENT_ONBOARDING_UPLOAD_SELECT"] = "選択";
translations["MSG_PARENT_ONBOARDING_UPLOAD_TITLE"] = "アイコンをアップロード";
translations["MSG_PARENT_PAGE_ACCOUNT_ACTIONS"] = "アカウント操作";
translations["MSG_PARENT_PAGE_ACCOUNT_CREATED_DATE"] = "アカウント追加日";
translations["MSG_PARENT_PAGE_ACCOUNT_INFO"] = "アカウント情報";
translations["MSG_PARENT_PAGE_ACCOUNT_STATUS"] = "アカウント状態";
translations["MSG_PARENT_PAGE_ACTIVE"] = "アクティブ";
translations["MSG_PARENT_PAGE_ACTIVITY_AI_CHAT"] = "まなパルくんとお話ししました";
translations["MSG_PARENT_PAGE_ACTIVITY_APP_REVIEWED"] = "アプリを★%{rating}で評価しました";
translations["MSG_PARENT_PAGE_ACTIVITY_COURSE_CLEAR"] =
  "%{course}のステージ%{stage} レベル%{level}をクリア！";
translations["MSG_PARENT_PAGE_ACTIVITY_DEFAULT"] = "活動しました";
translations["MSG_PARENT_PAGE_ACTIVITY_FAVORITED_RECEIVED"] = "いいねをもらいました";
translations["MSG_PARENT_PAGE_ACTIVITY_FEEDBACK_SENT"] = "フィードバックを送信しました";
translations["MSG_PARENT_PAGE_ACTIVITY_ICON_CHANGED"] = "アイコンを変更しました";
translations["MSG_PARENT_PAGE_ACTIVITY_INQUIRY_SENT"] = "問い合わせを送信しました";
translations["MSG_PARENT_PAGE_ACTIVITY_LOGIN"] = "ログインしました";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_CREATED"] = "「%{name}」を作成しました";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_FAVORITED"] = "「%{name}」にいいねしました";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_PUBLISHED"] = "「%{name}」を公開しました";
translations["MSG_PARENT_PAGE_ADD"] = "追加";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_MESSAGE"] =
  "現在のプランでは最大{{limit}}人までユーザーを追加できます。\nプランをアップグレードすると、より多くのユーザーを追加できます。";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_TITLE"] = "ユーザーを追加できません";
translations["MSG_PARENT_PAGE_AGE"] = "年齢";
translations["MSG_PARENT_PAGE_AI_CHAT"] = "まなパルくんとのおはなし";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_1"] = "質問や相談に答えてくれる";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_2"] = "お子様の好奇心を育む会話体験";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_3"] = "アイデアの相談もできる";
translations["MSG_PARENT_PAGE_AI_CHAT_FEATURE"] = "まなパルくんとのおはなし";
translations["MSG_PARENT_PAGE_AI_CHAT_FREE_LIMIT"] = "8回/日";
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY"] = "まなパルくんとの会話履歴";
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY_EMPTY"] = "まだ会話履歴がありません";
translations["MSG_PARENT_PAGE_AI_CHAT_MESSAGE_COUNT"] = "%{count}件のメッセージ";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_MESSAGES"] = "メッセージがありません";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_TITLE"] = "タイトルなし";
translations["MSG_PARENT_PAGE_AI_CHAT_PREMIUM_LIMIT"] = "無制限";
translations["MSG_PARENT_PAGE_AI_CHAT_STANDARD_LIMIT"] = "無制限";
translations["MSG_PARENT_PAGE_AI_CHAT_TAGLINE"] = "AIキャラクターと楽しく会話できる！";
translations["MSG_PARENT_PAGE_AI_GENERATION"] = "AIで素材作成";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_1"] = "オリジナルアイコンを作成";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_2"] = "「じゆうにつくる」の素材に";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_3"] = "チャットにも送れる";
translations["MSG_PARENT_PAGE_AI_IMAGE_FEATURE"] = "AIで素材画像生成";
translations["MSG_PARENT_PAGE_AI_IMAGE_FREE_LIMIT"] = "2回/日";
translations["MSG_PARENT_PAGE_AI_IMAGE_PREMIUM_LIMIT"] = "無制限（同時3枚生成）";
translations["MSG_PARENT_PAGE_AI_IMAGE_STANDARD_LIMIT"] = "10回/日";
translations["MSG_PARENT_PAGE_AI_IMAGE_TAGLINE"] = "想像したものを画像にできる！";
translations["MSG_PARENT_PAGE_APPLE_ID"] = "Apple ID";
translations["MSG_PARENT_PAGE_APP_DESCRIPTION"] =
  "保護者アプリを使って、お子様の学習状況を確認したり、設定を管理できます。";
translations["MSG_PARENT_PAGE_BASIC_INFO"] = "基本情報";
translations["MSG_PARENT_PAGE_BILLING_PERIOD"] = "請求期間";
translations["MSG_PARENT_PAGE_BIRTHDAY"] = "誕生日";
translations["MSG_PARENT_PAGE_BIRTHDAY_EDIT_TITLE"] = "誕生日変更";
translations["MSG_PARENT_PAGE_CHANGE"] = "変更";
translations["MSG_PARENT_PAGE_CHANGE_PASSWORD"] = "パスワードを変更";
translations["MSG_PARENT_PAGE_STORAGE_FEATURE"] = "データの保存容量";
translations["MSG_PARENT_PAGE_STORAGE_FREE_LIMIT"] = "1GB";
translations["MSG_PARENT_PAGE_STORAGE_STANDARD_LIMIT"] = "5GB";
translations["MSG_PARENT_PAGE_STORAGE_PREMIUM_LIMIT"] = "50GB";
translations["MSG_PARENT_PAGE_PLAYER_AI_IMAGE"] = "AI画像";
translations["MSG_PARENT_PAGE_PLAYER_ALBUM"] = "アルバム";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS"] = "素材一覧";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_EMPTY"] = "まだ素材がありません";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_LIST"] = "素材一覧";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_CREATED"] = "作成日";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_SIZE"] = "サイズ";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_UNNAMED"] = "名前なし";
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS"] = "作品一覧";
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS_EMPTY"] = "まだアプリがありません";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_COPIES"] = "回コピー";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_CREATED"] = "作成日";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_LIKES"] = "いいね";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_PUBLISHED"] = "公開中";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UNPUBLISHED"] = "未公開";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UPDATED"] = "更新日";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_VIEWS"] = "回閲覧";
translations["MSG_PARENT_PAGE_PLAYER_SHOW_MORE"] = "もっと見る";
translations["MSG_PARENT_PAGE_PLAYER_SKETCHBOOK"] = "スケッチブック";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_MESSAGE"] = "新しい名前を入力してください";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_TITLE"] = "名前変更";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_BUG"] = "不具合報告";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_HOW_TO"] = "使い方について";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_OTHER"] = "自己紹介";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_REQUEST"] = "機能リクエスト";
translations["MSG_PARENT_PAGE_COPY_PERMISSION"] = "コピー許可";
translations["MSG_PARENT_PAGE_CORPORATE_ALLOWED_CONTENT"] = "許可されたコンテンツ（カセット）";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_CODE_INPUT"] = "認証コード入力";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_DESCRIPTION"] =
  "『まなんでパズル』認証コード（企業提携コード）をお持ちの方は、下記に指定されたコードを入力してください。";
translations["MSG_PARENT_PAGE_CORPORATE_CODE"] = "企業連携コード";
translations["MSG_PARENT_PAGE_CORPORATE_CONFIRM"] = "決定";
translations["MSG_PARENT_PAGE_CORPORATE_DESCRIPTION"] =
  "企業提携コードをお持ちの方は、こちらから入力してください。";
translations["MSG_PARENT_PAGE_CORPORATE_NO_CONTENT"] =
  "許可された追加コンテンツ（カセット）はありません。";
translations["MSG_PARENT_PAGE_COURSE_ANSWER"] = "コースの解答を見る";
translations["MSG_PARENT_PAGE_COURSE_CLEAR"] = "コースクリア";
translations["MSG_PARENT_PAGE_CREATED_AT"] = "アカウント作成日";
translations["MSG_PARENT_PAGE_CREATED_PROJECTS"] = "つくった作品";
translations["MSG_PARENT_PAGE_CURRENT_PLAN"] = "現在のプラン";
translations["MSG_PARENT_PAGE_DANGER_ZONE"] = "危険な操作";
translations["MSG_PARENT_PAGE_DATE_FORMAT"] = "MM月DD日";
translations["MSG_PARENT_PAGE_DAY"] = "日";
translations["MSG_PARENT_PAGE_DELETE_BTN"] = "削除する";
translations["MSG_PARENT_PAGE_DELETE_CHILD"] = "このユーザーを削除";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MESSAGE"] =
  "{{name}}を削除すると、このユーザーの全てのデータ（進捗、作品など）が失われます。\nこの操作は取り消せません。";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_MESSAGE"] =
  "最低1人のユーザーが必要です。\n削除する前に別のユーザーを追加してください。";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_TITLE"] = "ユーザーを削除できません";
translations["MSG_PARENT_PAGE_DELETE_CHILD_TITLE"] = "ユーザーを削除しますか？";
translations["MSG_PARENT_PAGE_DELETE_CHILD_WARNING"] =
  "すべての学習データ・作品が削除されます。この操作は取り消せません。";
translations["MSG_PARENT_PAGE_DISPLAY_LANGUAGE"] = "表示言語";
translations["MSG_PARENT_PAGE_DOWNLOAD_PARENTS_APP"] = "保護者アプリをダウンロード";
translations["MSG_PARENT_PAGE_DOWNLOAD_KIDS_APP"] = "まなんでパズルをダウンロード";
translations["MSG_PARENT_PAGE_KIDS_APP_DESCRIPTION"] = "まなんでパズルアプリでお子さまと一緒に学習を楽しみましょう。";
translations["MSG_PARENT_PAGE_EDIT_BEST_SUBJECT"] = "得意教科を編集";
translations["MSG_PARENT_PAGE_EDIT_BODY_TYPE"] = "体型を編集";
translations["MSG_PARENT_PAGE_EDIT_FACE_SHAPE"] = "顔の形を編集";
translations["MSG_PARENT_PAGE_EDIT_FAVORITE_COLOR"] = "好きな色を編集";
translations["MSG_PARENT_PAGE_EDIT_GLASSES"] = "メガネを編集";
translations["MSG_PARENT_PAGE_EDIT_HAIRSTYLE"] = "髪型を編集";
translations["MSG_PARENT_PAGE_EDIT_SELF_INTRO"] = "自己紹介を編集";
translations["MSG_PARENT_PAGE_EDUCATION_DESCRIPTION"] =
  "教室プランをご利用中です。詳しくは管理者にお問い合わせください。";
translations["MSG_PARENT_PAGE_EMAIL"] = "メールアドレス";
translations["MSG_PARENT_PAGE_EMAIL_VERIFIED"] = "メール認証";
translations["MSG_PARENT_PAGE_ENABLE_CORPORATE"] = "企業認証コードを入力";
translations["MSG_PARENT_PAGE_FEEDBACK_DETAIL"] = "フィードバック詳細";
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY"] = "フィードバック履歴";
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY_EMPTY"] = "まだフィードバックがありません";
translations["MSG_PARENT_PAGE_FEEDBACK_PENDING"] = "未返信";
translations["MSG_PARENT_PAGE_FEEDBACK_RATING_SUMMARY"] = "アプリを★%{rating}で評価しました";
translations["MSG_PARENT_PAGE_FEEDBACK_REPLIED"] = "返信済み";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_CONTACT"] = "お問い合わせ";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_FEEDBACK"] = "フィードバック";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_RATING"] = "アプリの評価";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_MESSAGE"] =
  "このプレイヤーは停止中のため、ログインに切り替えることができません。先にプレイヤーを有効化してください。";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_TITLE"] = "切り替えできません";
translations["MSG_PARENT_PAGE_GENDER"] = "性別";
translations["MSG_PARENT_PAGE_GENDER_EDIT_TITLE"] = "性別変更";
translations["MSG_PARENT_PAGE_GOOGLE_ACCOUNT"] = "Googleアカウント";
translations["MSG_PARENT_PAGE_HIRAGANA"] = "ひらがな";
translations["MSG_PARENT_PAGE_ICON"] = "アイコン";
translations["MSG_PARENT_PAGE_INACTIVE"] = "非アクティブ";
translations["MSG_PARENT_PAGE_KANJI"] = "漢字";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_MESSAGE"] = "表示言語を選択してください";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_TITLE"] = "表示言語変更";
translations["MSG_PARENT_PAGE_LANGUAGE_EN"] = "英語";
translations["MSG_PARENT_PAGE_LANGUAGE_JA"] = "日本語";
translations["MSG_PARENT_PAGE_LANGUAGE_ZH_CN"] = "簡体字";
translations["MSG_PARENT_PAGE_LANGUAGE_ZH_TW"] = "繁体字";
translations["MSG_PARENT_PAGE_LEARNING_SUPPORT"] = "学習サポート";
translations["MSG_PARENT_PAGE_LINK"] = "連携する";
translations["MSG_PARENT_PAGE_LOGOUT"] = "ログアウト";
translations["MSG_PARENT_PAGE_MESSAGE_INPUT_PLACEHOLDER"] = "メッセージを入力...";
translations["MSG_PARENT_PAGE_MESSAGE_LOAD_MORE"] = "もっとみる";
translations["MSG_PARENT_PAGE_MESSAGE_NO_MESSAGES"] = "メッセージはまだありません";
translations["MSG_PARENT_PAGE_MESSAGE_NO_ROOMS"] = "チャットルームがありません";
translations["MSG_PARENT_PAGE_MONTH"] = "月";
translations["MSG_PARENT_PAGE_NICKNAME"] = "ニックネーム";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_MESSAGE"] = "新しいニックネームを入力してください";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_TITLE"] = "ニックネームを変更";
translations["MSG_PARENT_PAGE_NICKNAME_ERROR_MESSAGE"] = "他の名前をお試しください";
translations["MSG_PARENT_PAGE_NOT_SET"] = "未設定";
translations["MSG_PARENT_PAGE_NO_ACTIVITY_24H"] = "24時間以内の活動はありません";
translations["MSG_PARENT_PAGE_PEOPLE"] = "人";
translations["MSG_PARENT_PAGE_PLAN_COMPARISON"] = "プラン比較";
translations["MSG_PARENT_PAGE_PLAN_INFO"] = "プラン情報";
translations["MSG_PARENT_PAGE_PLAN_SCOPE_ACCOUNT"] = "アカウント全体";
translations["MSG_PARENT_PAGE_PLAN_SCOPE_PLAYER"] = "プレイヤーごと";
translations["MSG_PARENT_PAGE_PLAYABLE"] = "プレイ可能";
translations["MSG_PARENT_PAGE_PROFILE_BASIC_INFO"] = "基本情報";
translations["MSG_PARENT_PAGE_PROFILE_NOTES"] = "自己紹介";
translations["MSG_PARENT_PAGE_PROFILE_NOT_SET"] = "未設定";
translations["MSG_PARENT_PAGE_PROFILE_SECTION_TITLE"] = "プロフィール情報";
translations["MSG_PARENT_PAGE_USAGE_SECTION_TITLE"] = "利用状況";
translations["MSG_PARENT_PAGE_USAGE_PLAYERS"] = "プレイヤー数";
translations["MSG_PARENT_PAGE_USAGE_STORAGE"] = "データの保存容量";
translations["MSG_PARENT_PAGE_USAGE_CHAT_HISTORY"] = "チャット履歴";
translations["MSG_PARENT_PAGE_USAGE_ITEMS"] = "件";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_ERROR"] = "プロフィールの更新に失敗しました";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_SUCCESS"] = "プロフィールを更新しました";
translations["MSG_PARENT_PAGE_PROJECTS"] = "作品";
translations["MSG_PARENT_PAGE_PROJECT_COUNT"] = "「じゆうにつくる」の作品数";
translations["MSG_PARENT_PAGE_PROJECT_PUBLISH"] = "作品の公開";
translations["MSG_PARENT_PAGE_PUBLISHED_PROJECTS"] = "公開した作品";
translations["MSG_PARENT_PAGE_RECEIVED_LIKES"] = "もらったいいね";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY"] = "最近の活動";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY_24H"] = "最近24時間の活動";
translations["MSG_PARENT_PAGE_SETTINGS"] = "設定";
translations["MSG_PARENT_PAGE_SNS_LINK"] = "アカウント連携";
translations["MSG_PARENT_PAGE_SUBSCRIPTION_SOURCE"] = "購入方法";
translations["MSG_PARENT_PAGE_SUSPENDED"] = "停止中";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_MESSAGE"] = "「%{name}」に切り替えます。";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_TITLE"] = "プレイヤーを切り替えますか？";
translations["MSG_PARENT_PAGE_SWITCH_LOGIN"] = "切り替え";
translations["MSG_PARENT_PAGE_TAB_ACCOUNT"] = "アカウント";
translations["MSG_PARENT_PAGE_TAB_APPEARANCE"] = "見た目";
translations["MSG_PARENT_PAGE_TAB_BASIC"] = "基本情報";
translations["MSG_PARENT_PAGE_TAB_PLAYER"] = "プレイヤー";
translations["MSG_PARENT_PAGE_TAB_FAVORITES"] = "個性";
translations["MSG_PARENT_PAGE_TAB_MESSAGE"] = "メッセージ";
translations["MSG_PARENT_PAGE_TAB_NOTIFICATION"] = "お知らせ";
translations["MSG_PARENT_PAGE_TAB_OTHER"] = "その他";
translations["MSG_PARENT_PAGE_TAB_SUBSCRIPTION"] = "課金管理";
translations["MSG_PARENT_PAGE_TODAY"] = "今日";
translations["MSG_PARENT_PAGE_UNLIMITED"] = "無制限";
translations["MSG_PARENT_PAGE_UNLINK"] = "連携解除";
translations["MSG_PARENT_PAGE_UPGRADE_SECTION"] = "プラン購入";
translations["MSG_PARENT_PAGE_USER_COUNT"] = "プレイヤー数";
translations["MSG_PARENT_PAGE_VERIFIED"] = "認証済み";
translations["MSG_PARENT_PAGE_VIEW_TUTORIAL"] = "チュートリアルを見る";
translations["MSG_PARENT_PAGE_YEAR"] = "年";
translations["MSG_PARENT_PAGE_YEARS_OLD"] = "歳";
translations["MSG_PARENT_PAGE_YESTERDAY"] = "昨日";
translations["MSG_PARENT_PROFILE_APPEARANCE"] = "見た目";
translations["MSG_PARENT_PROFILE_FAMILY"] = "家族構成";
translations["MSG_PARENT_PROFILE_REGION"] = "お住まい";
translations["MSG_PARENT_PROFILE_WORK"] = "就業状況";
translations["MSG_PLAN_BUILDER_PARENT"] = "ビルダー";
translations["MSG_PLAN_EDUCATION_PARENT"] = "教室";
translations["MSG_PLAN_FREE_FULL_PARENT"] = "無料プラン";
translations["MSG_PLAN_TRIAL_PARENT"] = "体験";
translations["MSG_PLAN_FREE_PARENT"] = "無料";
translations["MSG_PLAN_PREMIUM_FULL_PARENT"] = "特別プラン";
translations["MSG_PLAN_PREMIUM_PARENT"] = "特別";
translations["MSG_PLAN_STANDARD_FULL_PARENT"] = "基本プラン";
translations["MSG_PLAN_STANDARD_PARENT"] = "基本";
translations["MSG_PREFECTURE_TITLE"] = "都道府県";
translations["MSG_PROFILE_AI_BEST_SUBJECTS_BY_PARENT"] = "得意な教科";
translations["MSG_PROFILE_AI_BODY_TYPE_BY_PARENT"] = "体型";
translations["MSG_PROFILE_AI_FACE_SHAPE_BY_PARENT"] = "顔の形";
translations["MSG_PROFILE_AI_FAVORITE_COLOR_PARENT"] = "好きな色";
translations["MSG_PROFILE_AI_GLASSES"] = "メガネ";
translations["MSG_PROFILE_AI_HAIRSTYLE_BY_PARENT"] = "髪型";
translations["MSG_PROFILE_AI_OTHER_INFO_PLACEHOLDER_BY_PARENT"] = "お子さまのことを書いてください";
translations["MSG_PROFILE_SUBSTEP_BIRTHDAY_BY_PARENT"] = "誕生日";
translations["MSG_PROFILE_SUBSTEP_GENDER_BY_PARENT"] = "性別";
translations["MSG_PROFILE_SUBSTEP_ICON_BY_PARENT"] = "アイコン";
translations["MSG_PROFILE_STEP_GENDER_DESC"] = "あなたの性別を選んでください。";
translations["MSG_PROFILE_STEP_BIRTHDAY_DESC"] = "あなたの誕生日を選んでください。";
translations["MSG_PROFILE_STEP_APPEARANCE_DESC"] = "選択肢の中から近いものを選んでください。";
translations["MSG_PROFILE_STEP_WORK_DESC"] = "就業状況を選んでください。";
translations["MSG_PROFILE_STEP_REGION_DESC"] = "お住いの都道府県と地域を選んでください。";
translations["MSG_PROFILE_STEP_FAMILY_DESC"] = "同居されているご家族を選んでください（複数回答可）";
translations["MSG_REAUTH_BACK"] = "戻る";
translations["MSG_REAUTH_PASSWORD_RESET_CONFIRM"] =
  "パスワードリセットメールを以下のアドレスに送信します";
translations["MSG_REAUTH_SSO_MESSAGE"] = "続けるにはもう一度ログインしてください";
translations["MSG_REAUTH_TITLE"] = "本人確認";
translations["MSG_RESTRICTED_FEATURE_BTN_VIEW_PLANS"] = "プランを変更";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HARD_TO_USE"] = "使いづらい";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HOW_TO_USE"] = "使い方が\nわからない";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_DIFFICULT"] = "難しすぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_EASY"] = "簡単すぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_FEW"] = "ステージが\n少なすぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_MANY"] = "ステージが\n多すぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_CREATE"] = "うまく\n作れない";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_USE"] = "使い方が\n難しい";
translations["MSG_REVIEW_FEEDBACK_TYPE_NONE"] = "不満はない";
translations["MSG_SELECT_PLACEHOLDER_BY_PARENT"] = "選択してください";
translations["MSG_SETTING_FOOTER_GO_TO_SITE"] = "『まなんでパズル』のサイトへ";
translations["MSG_SETTING_FOOTER_INQUIRY"] = "お問い合わせ";
translations["MSG_SETTING_FOOTER_PRIVACY_POLICY"] = "プライバシーポリシー";
translations["MSG_SETTING_FOOTER_TERMS_OF_SERVICE"] = "ご利用規約";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_MESSAGE"] =
  "ログイン中のユーザーは停止できません。\n別のユーザーに切り替えてから、このユーザーを停止してください。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_TITLE"] = "変更できません";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_MESSAGE"] =
  "有効化できるユーザーの数は最大４人までです。\nこのユーザーを有効化する場合には、ほかの不要なユーザーを無効化（もしくは削除）を行なってください。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_TITLE"] = "有効化できません";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_MESSAGE"] =
  "最低でも１名のユーザーが必要です。\nこれ以上ユーザーを減らすことはできません。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_TITLE"] = "変更できません";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_MESSAGE"] =
  "このユーザーのプレイを中止します。";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_TITLE"] = "プレイを中止します";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_MESSAGE"] = "このユーザーのプレイを再開します。";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_TITLE"] = "プレイを再開します";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_AUTH_CODE_TITLE"] = "認証コード";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_MESSAGE"] =
  "ソーシャルアカウントはすでに別のアカウントと連携しました。";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_TITLE"] =
  "連携ができません";
translations["MSG_SETTING_PARENTS_USER_PROFILE_UNSUBSCRIBE_BTN"] = "アカウント削除";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_MESSAGE"] =
  "・アカウントをログアウトすると、今お使いのユーザーで遊ぶことができなくなります。\n・ユーザーの情報はアカウントに保存されますので、また同じユーザーで遊びたい場合は、このアカウントで再度ログインを行ってください。";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_TITLE"] = "ログアウトします";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FORM_TITLE"] =
  "アカウント削除の理由を教えてください。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_MESSAGE"] =
  "アカウント削除するとアカウント・ユーザーを含むすべてのデータが削除されます。\nアカウント削除処理は復旧することができません。ご注意ください。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_TITLE"] = "本当にアカウント削除しますか？";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_MESSAGE"] =
  "『まなんでパズル』からアカウント削除すると、下記のデータの全てが削除されます。\n・登録したプロフィール情報やアカウント情報。\n・登録した全員分のユーザー情報。\n・ユーザーが作成した「じゆうにつくる」のアプリ。\n・ユーザーがクリアした「コースでまなぶ」の全ての成績やクリア実績。\n・ユーザーが行ってきた「トーク履歴」等。\n※ 【重要】ログインしているアカウントの削除を行うと、本アカウントに関連するすべてのデータ削除されますので、十分にご注意ください。\n※ 【重要】この作業はいかなる場合も復旧することはできません。アカウントを削除する場合は十分にご注意ください。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_TITLE"] = "【重要】ご注意ください";
translations["MSG_SETTING_TITLE_CORPORATE_AUTH"] = "企業連携認証";
translations["MSG_SETTING_TITLE_COURSE_ANSWER"] = "コースの解答を見る";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD"] = "現在のパスワード";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD"] = "新しいパスワード";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD_CONFIRM"] = "パスワードを確認";
translations["MSG_SIGN_EMAIL_SENT"] = "メールを送信しました";
translations["MSG_SIGN_IN_BTN"] = "ログイン";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_CURRENT_PASSWORD_WRONG"] =
  "入力したパスワードが間違っています。";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SUCCESS_CONTENT"] = "パスワード変更成功しました。";
translations["MSG_SIGN_IN_FAILED_MESSAGE"] = "メールアドレスかパスワードが間違っています。";
translations["MSG_SIGN_IN_FAILED_TITLE"] = "ログイン失敗";
translations["MSG_SIGN_IN_FORGOT_PASSWORD"] = "パスワードを忘れた場合";
translations["MSG_SIGN_IN_SUCCESS_CONTENT"] = "ログイン成功しました。";
translations["MSG_SIGN_IN_WITH_APPLE"] = "Appleで続ける";
translations["MSG_SIGN_IN_WITH_GOOGLE"] = "Googleで続ける";
translations["MSG_SIGN_PASSWORD_RESET_FAILED"] =
  "パスワードリセットメールの送信に失敗しました。もう一度お試しください。";
translations["MSG_SIGN_PASSWORD_RESET_SEND_BTN"] = "リセットメール送信";
translations["MSG_SIGN_PASSWORD_RESET_DESCRIPTION"] =
  "以下のメールアドレスにパスワードリセット用のメールを送信します。";
translations["MSG_SIGN_PASSWORD_RESET_SENT"] = "パスワードリセット用のメールを送信しました。";
translations["MSG_CLOSE_BTN_BY_PARENT"] = "閉じる";
translations["MSG_SIGN_USER_PASSWORD"] = "パスワード";
translations["MSG_SUBJECT_ART_BY_PARENT"] = "図工";
translations["MSG_SUBJECT_ENGLISH_BY_PARENT"] = "英語";
translations["MSG_SUBJECT_ETHICS_BY_PARENT"] = "道徳";
translations["MSG_SUBJECT_HOME_EC_BY_PARENT"] = "家庭";
translations["MSG_SUBJECT_JAPANESE_BY_PARENT"] = "国語";
translations["MSG_SUBJECT_MATH_BY_PARENT"] = "算数";
translations["MSG_SUBJECT_MUSIC_BY_PARENT"] = "音楽";
translations["MSG_SUBJECT_PE_BY_PARENT"] = "体育";
translations["MSG_SUBJECT_PROGRAMMING_BY_PARENT"] = "プログラミング";
translations["MSG_SUBJECT_SCIENCE_BY_PARENT"] = "理科";
translations["MSG_SUBJECT_SOCIAL_BY_PARENT"] = "社会";
translations["MSG_SUBSCRIPTION_ANNUAL_LABEL"] = "年額";
translations["MSG_SUBSCRIPTION_ANNUAL_TITLE"] = "年額プラン";
translations["MSG_SUBSCRIPTION_MANAGE"] = "サブスク管理";
translations["MSG_SUBSCRIPTION_MANAGE_APP_STORE_MESSAGE"] =
  "App Storeで購入されたサブスクリプションの管理はApp Storeで行ってください";
translations["MSG_SUBSCRIPTION_MANAGE_PLAY_STORE_MESSAGE"] =
  "Google Playで購入されたサブスクリプションの管理はGoogle Playで行ってください";
translations["MSG_SUBSCRIPTION_MONTHLY_LABEL"] = "月額";
translations["MSG_SUBSCRIPTION_MONTHLY_TITLE"] = "月額プラン";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_MESSAGE"] =
  "このサブスクリプションは別のプラットフォームで購入されました";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_TITLE"] = "別のプラットフォームで購入";
translations["MSG_SUBSCRIPTION_AMAZON_NOT_SUPPORTED_TITLE"] = "Amazonでは購入できません";
translations["MSG_SUBSCRIPTION_AMAZON_NOT_SUPPORTED_MESSAGE"] =
  "Amazonアプリでは購入機能をご利用いただけません。Webブラウザからまなんでパズルにアクセスし、同じアカウントでログインしてからご購入ください。";
translations["MSG_SUBSCRIPTION_PORTAL_ERROR"] = "ポータルを開けませんでした";
translations["MSG_SUBSCRIPTION_PURCHASE_BTN"] = "購入する";
translations["MSG_SUBSCRIPTION_PURCHASE_ERROR"] = "購入に失敗しました。もう一度お試しください。";
translations["MSG_SUBSCRIPTION_PURCHASE_SUCCESS"] = "購入が完了しました！";
translations["MSG_SUBSCRIPTION_STORE_MANAGE_TITLE"] = "サブスクリプション管理";
translations["MSG_TOAST_DELETED_SUCCESS"] = "削除しました";
translations["MSG_TOAST_EDIT_SUCCESS"] = "変更しました";
translations["MSG_TOAST_ERROR"] = "エラーが発生しました";
translations["MSG_TOAST_FILE_TOO_LARGE"] = "ファイルが大きすぎます";
translations["MSG_TOAST_SEND_FAILED"] = "送信失敗しました";
translations["MSG_UPLOAD_ICON_HINT_BY_PARENT"] = "JPG、PNG形式、5MBまで";
translations["MSG_UPLOAD_ICON_SELECT_BY_PARENT"] = "画像を選択";
translations["MSG_UPLOAD_ICON_TITLE_BY_PARENT"] = "画像をアップロード";
translations["MSG_USER_NAME_LENGTH_LIMIT"] = "名前は10文字以内で入力してください";
translations["MSG_USER_NAME_REQUIRED"] = "名前を入力してください";
translations["MSG_PARENT_PAGE_PLAYER_EMPTY_TITLE"] = "プレイヤーがいません";
translations["MSG_PARENT_PAGE_PLAYER_EMPTY_MESSAGE"] = "お子さまを追加して学習を始めましょう";
translations["MSG_PARENT_PAGE_PLAYER_ADD_BTN"] = "プレイヤーを追加";
translations["MSG_PARENT_PAGE_LAUNCH_APP"] = "まなんでパズルを起動";
translations["MSG_PARENT_PAGE_NO_PLAYER_WARNING_TITLE"] = "プレイヤーがいません";
translations["MSG_PARENT_PAGE_NO_PLAYER_WARNING_MESSAGE"] =
  "まなんでパズルを起動するには、先にプレイヤーを追加してください。";

// PlayerIconEditor
translations["MSG_PLAYER_ICON_EDITOR_TITLE"] = "アイコン変更";

// CreatePlayerModal
translations["MSG_PARENT_PAGE_CREATE_PLAYER_TITLE"] = "プレイヤーを追加";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_ICON_TITLE"] = "アイコンを選択";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_CONFIRM_TITLE"] = "確認";
translations["MSG_TOAST_CREATE_PLAYER_SUCCESS"] = "プレイヤーを追加しました";
translations["MSG_CREATE_USER_PREVIEW_MESSAGE_BY_PARENT"] = "この内容でプレイヤーを登録します";
translations["MSG_PRESET_ICON_TITLE_BY_PARENT"] = "アイコンを選んでください";
translations["MSG_ICON_CATEGORY_ALL_BY_PARENT"] = "すべて";
translations["MSG_UPLOAD_ICON_DRAG_DROP_BY_PARENT"] = "ここに画像をドラッグ&ドロップ";
translations["MSG_UPLOAD_ICON_CLICK_BY_PARENT"] = "またはクリックして画像を選択";
translations["MSG_UPLOAD_ICON_REMOVE_BY_PARENT"] = "削除";
translations["MSG_UPLOAD_ICON_TYPE_ERROR"] = "JPGまたはPNG形式の画像を選択してください";
translations["MSG_UPLOAD_ICON_SIZE_ERROR"] = "ファイルサイズは5MB以下にしてください";
translations["MSG_SELECT_PLACEHOLDER"] = "選択してください";
translations["MSG_COLOR_SELECT_SHADE_BY_PARENT"] = "好きな色味を選んでください";
translations["MSG_PROFILE_AI_APPEARANCE_BY_PARENT"] = "見た目";

// CreatePlayerModal - 追加キー（メインi18nからコピー）
translations["MSG_CREATE_USER_TITLE_GENDER_BY_PARENT"] = "お子さまの性別";
translations["MSG_CREATE_USER_TITLE_BIRTHDAY_BY_PARENT"] = "お子さまの生年月日";
translations["MSG_CREATE_USER_TITLE_PREVIEW_BY_PARENT"] = "登録内容の確認";
translations["MSG_CREATE_USER_BTN_NEXT_BY_PARENT"] = "次へ";
translations["MSG_CREATE_USER_BTN_GENERATE_BY_PARENT"] = "アイコンを作る";
translations["MSG_CREATE_USER_STEP_NAME_BY_PARENT"] = "名前";
translations["MSG_CREATE_USER_STEP_ICON_BY_PARENT"] = "アイコン";
translations["MSG_CREATE_USER_STEP_CONFIRM_BY_PARENT"] = "確認";
translations["MSG_USER_PROFILE_DEFAULT_NAME"] = "名前%{random}";
translations["MSG_USER_PROFILE_INPUT_NAME_PROMPT_BY_PARENT"] = "お子さまの名前を入力してください";
translations["MSG_PROFILE_AI_FAVORITE_COLOR_BY_PARENT"] = "好きな色";
translations["MSG_SUBJECT_LANGUAGE_BY_PARENT"] = "国語";
translations["MSG_SUBJECT_LIFE_BY_PARENT"] = "生活";
translations["MSG_SUBJECT_INTEGRATED_BY_PARENT"] = "総合";
translations["MSG_SUBJECT_SPECIAL_ACTIVITIES_BY_PARENT"] = "特活";

// CreatePlayerModal - ステップバーラベル
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_NAME"] = "名前";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_LANGUAGE"] = "言語";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_ICON"] = "アイコン";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_CONFIRM"] = "確認";
translations["MSG_CREATE_USER_TITLE_LANGUAGE_BY_PARENT"] = "お子さまの表示言語を選択してください";
translations["MSG_USER_PROFILE_NAME_PLACEHOLDER_BY_PARENT"] = "お子様の名前";

// CreatePlayerModal - サブステップラベル（6ステップ）
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_GENDER"] = "性別";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_BIRTHDAY"] = "生年月日";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_APPEARANCE"] = "容姿";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_COLOR"] = "好きな色";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_BEST_SUBJECT"] = "得意な教科";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_ICON"] = "アイコン";

// Asset削除
translations["MSG_PARENT_PAGE_PLAYER_ASSET_DELETE_BTN"] = "削除する";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_DELETE_TITLE"] = "素材を削除しますか？";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_DELETE_MESSAGE"] =
  "「%{name}」を削除します。\n削除すると復元できません。";

// 認証画面用
translations["MSG_SIGN_IN_WITH_MAIL"] = "メールでログイン";
translations["MSG_SIGN_NO_ACCOUNT_REGISTER"] = "アカウントがない方は新規登録";
translations["MSG_SIGN_PASSWORD_REQUIRED"] = "パスワードを入力してください";
translations["MSG_SIGN_LOGIN_FAILED"] = "メールアドレスかパスワードが間違っています。";
translations["MSG_SIGN_UP_BTN"] = "新規登録";
translations["MSG_SIGN_UP_WITH_MAIL"] = "メールで登録する";
translations["MSG_SIGN_ALREADY_ACCOUNT_LOGIN"] = "既にアカウントがある方はログイン";
translations["MSG_SIGN_PASSWORD_MISMATCH"] = "パスワードが一致しません";
translations["MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_MESSAGE"] =
  "このメールアドレスは既に登録されています。別のメールアドレスをお試しください。";
translations["MSG_SIGN_UP_FAILED"] = "アカウント作成に失敗しました。もう一度お試しください。";
translations["MSG_SIGN_UP_SUCCESS_CONTENT"] = "アカウント登録成功しました。";
translations["MSG_SIGN_UP_WITH_APPLE"] = "Appleで続ける";
translations["MSG_SIGN_USER_MAIL"] = "メールアドレス";
translations["MSG_SIGN_USER_PASSWORD_CONFIRM"] = "パスワード再入力";
translations["MSG_SIGN_EMAIL_REQUIRED"] = "メールアドレスを入力してください";
translations["MSG_SIGN_EMAIL_INVALID"] = "有効なメールアドレスを入力してください";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_TITLE"] = "パスワードリセット";
translations["MSG_SIGN_BACK_TO_LOGIN"] = "ログイン画面に戻る";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "保護者";

// アカウント削除モーダル
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_DESC_PREFIX"] =
  "登録したアカウントの削除をご希望の場合は";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_CLICK_HERE"] = "こちら";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_DESC_SUFFIX"] = "からお願いします。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_1"] = "今は（定期的）に使わなくなった";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_2"] = "コンテンツが不足してるから";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_3"] = "アプリが操作しにくかった";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_4"] = "起動やプレイの動作速度が遅かった";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_5"] = "通知などが面倒に感じた";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_6"] = "その他";
translations["MSG_NEXT_BTN"] = "次へ";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FEEDBACK_LABEL"] =
  "その他ご意見があればお聞かせください（任意）";

// 認証画面 - Onboarding戻るボタン
translations["MSG_AUTH_BACK_TO_START"] = "最初の画面に戻る";

// プラン比較表 - プレイヤー数
translations["MSG_PARENT_PAGE_USERS_FREE"] = "2人";
translations["MSG_PARENT_PAGE_USERS_STANDARD"] = "4人";
translations["MSG_PARENT_PAGE_USERS_PREMIUM"] = "8人";

// 購入情報の復元
translations["MSG_SUBSCRIPTION_RESTORE_BTN"] = "購入情報を復元";
translations["MSG_SUBSCRIPTION_RESTORE_SUCCESS_TITLE"] = "復元完了";
translations["MSG_SUBSCRIPTION_RESTORE_SUCCESS_MESSAGE"] = "購入情報を復元しました";

// 保護者プロフィール - 自分の役割
translations["MSG_USER_ROLE_TITLE"] = "あなた";

// 身につけるもの（Accessory）
translations["MSG_ACCESSORY_TITLE_BY_PARENT"] = "身につけるもの";
translations["MSG_ACCESSORY_NONE_BY_PARENT"] = "なし";
translations["MSG_ACCESSORY_MEGANE_BY_PARENT"] = "メガネ";
translations["MSG_ACCESSORY_BOUSHI_BY_PARENT"] = "帽子";
translations["MSG_ACCESSORY_HAIRPIN_BY_PARENT"] = "ヘアピン";
translations["MSG_ACCESSORY_RIBBON_BY_PARENT"] = "リボン";
translations["MSG_ACCESSORY_BANDAID_BY_PARENT"] = "ばんそうこう";
translations["MSG_PARENT_PAGE_EDIT_ACCESSORY"] = "身につけるものを編集";

// 共通ボタン（common/i18nから移行）
translations["MSG_CONFIRM_BTN"] = "決定";
translations["MSG_CANCEL_BTN"] = "キャンセル";
translations["MSG_STOP_BTN"] = "やめる";
translations["MSG_DELETE_BTN"] = "削除する";
translations["MSG_CLOSE_BTN"] = "閉じる";
translations["MSG_CURRENT_PLAN"] = "現在のプラン";

// プラン名（非PARENT版）
translations["MSG_PLAN_TRIAL"] = "体験";
translations["MSG_PLAN_FREE"] = "無料";
translations["MSG_PLAN_STANDARD"] = "基本";
translations["MSG_PLAN_PREMIUM"] = "特別";
translations["MSG_PLAN_BUILDER"] = "ビルダー";
translations["MSG_PLAN_EDUCATION"] = "教室";

// UpgradePromotion
translations["MSG_UPGRADE_PROMOTION_TITLE"] = "プランを変更して、もっと楽しもう！";
translations["MSG_UPGRADE_PROMOTION_TABLE_PLAN"] = "プラン";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS"] = "プレイヤー数";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_TRIAL"] = "1人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_FREE"] = "2人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_STANDARD"] = "4人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_PREMIUM"] = "8人";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS"] = "作品数";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_TRIAL"] = "1個";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_FREE"] = "5個";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_STANDARD"] = "10個";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_PREMIUM"] = "10個";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE"] = "AI画像";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_TRIAL"] = "1日1回";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_FREE"] = "1日2回";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_STANDARD"] = "1日10回";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_PREMIUM"] = "無制限\n（同時3枚）";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT"] = "まなパルくん";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_TRIAL"] = "1日4回";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_FREE"] = "1日8回";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_STANDARD"] = "無制限";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_PREMIUM"] = "無制限";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE"] = "データの保存容量";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_TRIAL"] = "100MB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_FREE"] = "1GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_STANDARD"] = "5GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_PREMIUM"] = "50GB";
translations["MSG_UPGRADE_PROMOTION_CHANGE_BTN"] = "変更";
translations["MSG_LOGIN_REQUIRED_TITLE"] = "ログインが必要です";
translations["MSG_LOGIN_REQUIRED_MESSAGE"] = "この機能を使用するには、アカウント登録が必要です。";

// Restricted Feature
translations["MSG_RESTRICTED_FEATURE_TITLE_COURSE"] = "コースはもう遊べない";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_COURSE"] =
  "今のプランではアルゴリズムをあそぼうのステージ1と2だけ遊べます。\nもっと遊びたいときは保護者に相談してください。";
translations["MSG_RESTRICTED_FEATURE_TITLE_PROJECT_LIMIT"] = "アプリはもう作れない";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_PROJECT_LIMIT"] =
  "今のプランではアプリは%{limit}個まで作れます。\nもっと作りたいときは保護者に相談してください。";
translations["MSG_RESTRICTED_FEATURE_TITLE_CHILD_USER_LIMIT"] = "プレイヤーは追加できない";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_CHILD_USER_LIMIT"] =
  "今のプランではプレイヤーは%{limit}人まで追加できます。\nもっと追加したいときは保護者に相談してください。";
translations["MSG_RESTRICTED_FEATURE_TITLE_CHILD_USER_ADD_TRIAL"] = "プレイヤーは追加できない";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_CHILD_USER_ADD_TRIAL"] =
  "体験プランではプレイヤーを追加できません。\nプレイヤーを追加したいときは保護者に相談してください。";
translations["MSG_RESTRICTED_FEATURE_TITLE_PARENT_SETTINGS"] = "このプランでは使えません";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_PARENT_SETTINGS"] =
  "体験プランでは保護者ページにアクセスできません。\n保護者アカウントの登録が必要です。";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_CHAT_LIMIT"] = "今日のAIチャット終わり";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_CHAT_LIMIT"] =
  "今のプランでは1日%{limit}回まで使えます。\n基本プランにアップグレードすると無制限で使えます。";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_IMAGE_LIMIT"] = "今日のAI画像終わり";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_IMAGE_LIMIT"] =
  "今のプランでは1日%{limit}回まで使えます。\n基本プランにアップグレードすると無制限で使えます。";
translations["MSG_RESTRICTED_FEATURE_TITLE_CHAT_IMAGE"] = "画像機能について";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_CHAT_IMAGE"] =
  "画像の送信は「特別プラン」で使えます。\n特別プランにアップグレードすると、画像を送ることができます。";
translations["MSG_RESTRICTED_FEATURE_TITLE_ASSET_LIMIT"] = "素材はもう使えない";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_ASSET_LIMIT"] =
  "今のプランでは素材は%{limit}個まで使用できます。\n基本プランにアップグレードすると無制限で使用できます。";
translations["MSG_RESTRICTED_FEATURE_BTN_TO_PARENTS"] = "保護者の方へ";
translations["MSG_GUEST_LOGIN_PROMPT_TITLE"] = "アカウント登録が必要です";
translations["MSG_GUEST_LOGIN_PROMPT_MESSAGE"] = "この機能を使用するには、アカウント登録が必要です。";

// Asset
translations["MSG_ASSET_DELETE_BTN"] = "削除";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_TITLE"] = "素材を削除しますか？";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_MESSAGE"] =
  "「%{name}」を削除します。この操作は取り消せません。";
translations["MSG_CREATOR_APP_NAME_PLACEHOLDER"] = "名前を入力";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_ALBUM_TITLE"] = "アルバム";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_DRAWING_TITLE"] = "おえかき";
translations["MSG_USER_STOCK_AI_TAB"] = "AI";
translations["MSG_USER_STOCK_AI_EMPTY"] = "AIで作った素材はまだありません";
translations["MSG_ASSET_ALBUM_EMPTY_MESSAGE"] = "アルバムには画像がありません";
translations["MSG_ASSET_DRAWING_EMPTY_MESSAGE"] = "おえかきした画像がありません";
translations["MSG_ASSET_ALBUM_ADD_TITLE"] = "追加";
translations["MSG_AI_TAB_GENERATE"] = "AIで作る";

// ParentGate
translations["MSG_PARENT_GATE_WARNING"] = "保護者の方へ";
translations["MSG_PARENT_GATE_TITLE"] = "以下の内容は保護者の方が操作してください";

// Auth
translations["MSG_AUTH_SELECTION_INSTRUCTION"] =
  "アカウントをお持ちの方は「ログイン」、初めての方は「新規登録」をお選びください。";
translations["MSG_AUTH_SIGN_IN"] = "ログイン";
translations["MSG_AUTH_SIGN_IN_DESC"] = "既存のアカウントでログイン";
translations["MSG_AUTH_SIGN_UP"] = "新規登録";
translations["MSG_AUTH_SIGN_UP_DESC"] = "新しいアカウントを作成";

// Chat
translations["MSG_USER_PROFILE_MESSAGE_PARENTS_TALK_WELCOME_TEXT"] = "が参加しました。";

// Misc
translations["MSG_BLOCKLY_INPUT_NUMBER_LIMIT"] = "数字を入力してください";
translations["MSG_ASSISTANT_STOP"] = "止める";

export default translations;
